<template>
  <v-dialog v-model="showNovaDemandaDialog" max-width="1100" max-height="680">
    <base-modal>
      <template v-if="params && params.length">
        <v-layout row v-show="!formSelecionado">
          <v-flex md6 sm12 v-for="item in params" :key="item.nome" :id="item.nome.replace(/ /g, '')">
            <v-card
              @click="setIframe(item.url_formulario)"
              class="card-equal-height"
            >
              <v-card-text class="text-center">
                <h2 class="mx-auto">
                  <v-icon class="mx-auto" :color="item.cor">{{
                    item.icone
                  }}</v-icon>
                </h2>
                <h2 class="mb-5 mt-5 mx-auto text-nome">{{ item.nome }}</h2>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>

        <iframe
          v-show="formSelecionado"
          width="100%"
          height="610"
          frameborder="0"
        ></iframe>
      </template>

      <h2
        id="Carregando"
        v-else
        class="title"
        v-html="'Carregando...'"
      ></h2>

      <v-layout row wrap>
        <v-flex offset-md10 md2 offset-sm6 sm6 pb-0>
          <button
            id="botao_fechar"
            class="button jns-button yellow-button"
            @click="fecharModal()"
          >
            Fechar
          </button>
        </v-flex>
      </v-layout>
    </base-modal>
  </v-dialog>
</template>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "NovasDemandasComponent",
  mixins: [ViewMixin],
  props: ["showNovaDemandaDialog"],
  data() {
    return { params: {}, formSelecionado: false };
  },
  methods: {
    async getParamDemandas() {
      try {
        var data = await this.$store.dispatch("GET_PARAMS_DEMANDAS");
        this.params = data.conteudo;
      } catch (e) {
        this.setErrorModal(e.response.data);
      } 
    },

    setIframe(url) {
      var iframe = document.getElementsByTagName("iframe")[0];
      if (iframe) iframe.src = url;

      this.formSelecionado = true;
    },

    fecharModal() {
      this.formSelecionado = false;
      this.$emit("setShowNovaDemandaDialog");
    },
  },
  created() {
    this.getParamDemandas();
  },
};
</script>

<style lang="scss" scoped>
h2 {
  display: table;
}

i {
  font-size: 8rem;
}

.card-equal-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.card-equal-height > v-card-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.text-nome {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// ./src/components/NovasDemandasComponent.vue